<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">门店服务&nbsp;/&nbsp;</span>
      </div>
      <div>缴费记录</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header space-between">
            <div class="flex-row">
              <el-select v-model="query.orderType" placeholder="审核状态" filterable @change="selectChange">
                <el-option label="全部" value></el-option>
                <el-option label="门店服务费" value="shopManage"></el-option>
                <el-option label="短信服务费" value="sms"></el-option>
              </el-select>
            </div>
            <!-- <el-button type="primary" @click="addList">请假申请</el-button> -->
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="itemName" label="商品名称" width="140px"></el-table-column>
              <el-table-column prop="orderTypeCn" label="订单类型" width="auto"></el-table-column>
              <el-table-column prop="orderStatusCn" label="订单状态" width="auto"></el-table-column>
              <el-table-column prop="orderAmount" width="auto" label="订单金额"></el-table-column>
              <el-table-column prop="itemNum" width="auto" label="数量"></el-table-column>
              <el-table-column prop="couponCardUse" width="100px" label="使用现金券">
                <template slot-scope="scope">{{ scope.row.couponCardUse == "no" ? '否': '是' }}</template>
              </el-table-column>
              <el-table-column prop="couponCode" width="160px" label="现金券券号"></el-table-column>
              <el-table-column prop="discountAmount" width="auto" label="优惠金额"></el-table-column>
              <el-table-column prop="realPayAmount" width="auto" label="付款金额"></el-table-column>
              <el-table-column prop="payWayCn" width="auto" label="支付方式"></el-table-column>
              <el-table-column prop="payTime" label="支付时间" width="160px">
                <template slot-scope="scope">{{ formatDate(scope.row.payTime) }}</template>
              </el-table-column>
              <el-table-column prop="oxCtime" label="创建时间" width="170px">
                <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
              </el-table-column>
              <el-table-column prop="sourceCn" width="auto" label="来源"></el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="140">
                <template slot-scope="scope">
                  <!-- <el-link type="primary" @click="details(scope.row)">详情</el-link> -->
                  <el-link type="primary" v-if="scope.row.orderStatus == 'waitPay' && scope.row.source != 'platformBackend'" @click="continuePay(scope.row)">继续支付</el-link>
                  <el-link type="primary" class="ml5" v-if="scope.row.orderStatus == 'waitPay' && scope.row.source != 'platformBackend'" @click="cancelOrder(scope.row)">取消订单</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <pay ref="payForm" @change="backChange"></pay>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import pay from "./pay.vue";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  data() {
    return {
      url: this.$url.shopServe.listOrder,
      query: {
        orderType: "",
        start: 0,
        size: 20
      },
      height: this.$store.getters.MainHeight,
      list: [],
      platformPayWay: 'weixin'
    };
  },
  mixins: [minxin],
  components: {pay},
  computed: {},

  created() {
    this.totalCounts();
    this.getConfig();
  },

  methods: {
    getConfig() { // 获取当前配置的支付方式
			this.$api.get(this.$url.shop.getConfig).then((res) => {
				if (res) {
          this.platformPayWay = res.platformPayWay == 'wxpay' ? 'weixin':'lakala';
				}
			})
		},
    back() {
      this.$router.push("/manage/shopServeed");
    },
    continuePay (row) {
      console.log(row);
      const obj = {
        itemId:row.itemId,
        itemNum:row.itemNum,
        orderId:row.id,
        payWay: '',
        source: 'pcCashier',
        itemType: row.orderType,
        payPlatform: this.platformPayWay
      }
      console.log('====');
      console.log(obj);
      this.wxOrlkl(row, obj)
    },
    
    wxOrlkl (row, obj) {
      this.$api.post(this.$url.shopServe.createAllPackage, encrypt(JSON.stringify(obj))).then((res) => {
        if (res) {
          // if (this.platformPayWay == 'weixin') {
            let parmar = {
              url: res.prePayResultMap.code_url,
              realPayAmount: row.realPayAmount,
              orderId: row.id,
              itemId: row.itemId,
              itemType: row.orderType,
              orderType: row.orderType,
              itemNum: row.itemNum,
              type: row.orderType == 'shopManage' ? 'shop' : 'sms',
              payPlatform: this.platformPayWay
            };
            this.$refs["payForm"].$emit("set", parmar);
          // }
          // else {
          //   this.$api.post(url, encrypt(JSON.stringify(obj))).then(res => {
          //     console.log(res);
          //     if (res) {
          //       console.log(res.payUrl);
          //       window.open(res.payUrl,'_self')
          //     }
          //   })
          // }
          
        }
      });
    },
    cancelOrder (row) {
      console.log(row, 'row');
      row.orderId=row.id;
      row.source = 'pcCashier';
      let that = this;
      this.$confirm('确认取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.wxOrlklCancelOrder(row)
      })
    },
    wxOrlklCancelOrder (row) {
      this.$api.post(this.$url.shopServe.cancelOrder, encrypt(JSON.stringify(row))).then(res => {
        if (res) {
          this.$message.success("操作成功");
          this.getData();
        }
      })
    },
    backChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    totalCounts () {
      this.$api.post(this.$url.shopServe.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    details () {
      
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    
    padding: 16px;
    display: flex;
  }
}
</style>

